import { hasCapability, type User } from "../base";

export const journalEntry = {
  create: (user: User) => hasCapability(user, "journalEntry.create"),
  read: (user: User) => hasCapability(user, "journalEntry.read"),
  delete: (user: User) => hasCapability(user, "journalEntry.delete"),
};
